/**
 * The spinner custom size has 640 options
 *
 * Hasil iseng wkwk 🙏🙏🙏
 */
const spinnerSizeCustomOption = {
  '|-005px': 'w-[5px] h-[5px]',
  '|-010px': 'w-[10px] h-[10px]',
  '|-015px': 'w-[15px] h-[15px]',
  '|-020px': 'w-[20px] h-[20px]',
  '|-025px': 'w-[25px] h-[25px]',
  '|-030px': 'w-[30px] h-[30px]',
  '|-035px': 'w-[35px] h-[35px]',
  '|-040px': 'w-[40px] h-[40px]',
  '|-045px': 'w-[45px] h-[45px]',
  '|-050px': 'w-[50px] h-[50px]',
  '|-055px': 'w-[55px] h-[55px]',
  '|-060px': 'w-[60px] h-[60px]',
  '|-065px': 'w-[65px] h-[65px]',
  '|-070px': 'w-[70px] h-[70px]',
  '|-075px': 'w-[75px] h-[75px]',
  '|-080px': 'w-[80px] h-[80px]',
  '|-085px': 'w-[85px] h-[85px]',
  '|-090px': 'w-[90px] h-[90px]',
  '|-095px': 'w-[95px] h-[95px]',
  '|-100px': 'w-[100px] h-[100px]',
  '|-105px': 'w-[105px] h-[105px]',
  '|-110px': 'w-[110px] h-[110px]',
  '|-115px': 'w-[115px] h-[115px]',
  '|-120px': 'w-[120px] h-[120px]',
  '|-125px': 'w-[125px] h-[125px]',
  '|-130px': 'w-[130px] h-[130px]',
  '|-135px': 'w-[135px] h-[135px]',
  '|-140px': 'w-[140px] h-[140px]',
  '|-145px': 'w-[145px] h-[145px]',
  '|-150px': 'w-[150px] h-[150px]',
  '|-155px': 'w-[155px] h-[155px]',
  '|-160px': 'w-[160px] h-[160px]',
}

export default spinnerSizeCustomOption
